export const EMPTY_PATH = "";

// FRONTOFFICE
export const HOME_PATH = "home";
export const ABOUT_PATH = "about";
export const FRONTOFFICE_LOGIN_PATH = "frontoffice-login";

// BACKOFFICE
export const BACKOFFICE_PATH = "private";
export const BACKOFFICEMAIN_PATH = "main";
export const BACKOFFICE_LOGIN_PATH = "backoffice-login";
export const PROFILE_PATH = "profile";
export const SPHERE_EDIT_PATH = "sphere-edit";
export const CHANGE_PASSWORD_PATH = "change-password";

export const NURSERIES_PATH = "nurseries";

// BACKOFFICE MAIN
export const LIST_PATH = "list";
export const EDIT_PATH = "edit";
export const ADD_PATH = "add";
export const DETAIL_PATH = "detail";
export const NURSERY_PATH = "nursery";
export const PROMOTION_PATH = "promotion";
export const SPHERE_PATH = "sphere";
export const MAP_PATH = "map";
export const LOG_PATH = "log";
